
















































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { ManualModel } from "../models";
import { namespace } from "vuex-class";

interface HTMLInputEvent extends Event {
  target: HTMLInputElement & EventTarget;
}

const mStore = namespace("manual");

@Component
export default class ManualForm extends Vue {
  @Prop({ required: true })
  value!: ManualModel;
  @Prop({ required: true })
  title!: string;
  @Prop({ required: true })
  thumbnail!: File | null;
  @Prop({ required: true })
  pdf!: File | null;
  @Prop({ default: false })
  reset!: boolean;
  @Prop({ default: false })
  filesOptional!: boolean | string;

  @mStore.Getter allTags!: string[];

  get filesRequired(): boolean {
    return this.filesOptional === false;
  }

  get manual() {
    return this.value;
  }
  set manual(m: ManualModel) {
    this.$emit("input", m);
  }

  @Watch("reset")
  resetValidator() {
    if (this.reset) {
      this.$validator.errors.remove("Tags");
      this.$validator.reset();
      this.$emit("update:reset", false);

      const pdf = this.$refs.pdfInput as HTMLInputElement;
      pdf.type = "text";
      pdf.type = "file";

      const thumbnail = this.$refs.thumbnailInput as HTMLInputElement;
      thumbnail.type = "text";
      thumbnail.type = "file";
    }
  }

  close() {
    this.$emit("close");
  }

  submit() {
    this.$validator.validateAll().then(ok => {
      if (!ok) return;

      if (this.manual.tags !== null) {
        for (let t of this.manual.tags) {
          if (t.length > 255) {
            this.$validator.errors.add({
              field: this.t("tags"),
              msg: this.$t("manuals.texts.tagError").toString()
            });
            return;
          }
        }
      }

      this.$emit("submit");
    });
  }

  removeTag(item: string) {
    if (this.manual.tags === null) this.manual.tags = [];
    this.manual.tags.splice(this.manual.tags.indexOf(item), 1);
    this.manual.tags = [...this.manual.tags];
  }

  setPdf(e?: HTMLInputEvent) {
    if (!e || e.target.files === null) return;
    this.$emit("update:pdf", e.target.files[0]);
  }

  setThumbnail(e?: HTMLInputEvent) {
    if (!e || e.target.files === null) return;
    this.$emit("update:thumbnail", e.target.files[0]);
  }

  private t(key: string): string {
    return this.$t("manuals.form." + key).toString();
  }
}
